import React from 'react';
import { useSelector } from 'react-redux';

import PresenceDot from '@sharedCR/common/PresenceDot';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { selectEntityNameMap } from 'store/loanApplications/selectors';
import { selectOtherUsersOnSubtab, selectOtherUsersOnTab } from 'store/presence/selectors';

const PresenceTabBadge = ({ tab, subtabRoute }) => {
  const selector = _.isNil(subtabRoute)
    ? selectOtherUsersOnTab(tab)
    : selectOtherUsersOnSubtab(subtabRoute);
  const otherUsers = useSelector(selector);

  const entityNameMap = useSelector(selectEntityNameMap);

  return <PresenceDot entityNameMap={entityNameMap} users={otherUsers} />;
};

PresenceTabBadge.propTypes = {
  tab: PropTypes.string.isRequired,
  subtabRoute: PropTypes.string,
};

export default PresenceTabBadge;
